<template lang="pug">
  app-combobox(v-model="items" v-bind="$attrs" :items="items" item-text="data" :active-item="activeItem" selectable @select="select")
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'case-member-databox',
  props: {
    value: Array,
    dataType: String
  },

  computed: {
    items: {
      get () {
        return this.value
      },
      set (val) {
        let list = val.map(item => (item instanceof Object) ? item : { data: item, dataType: this.dataType, tag: null })
        if (list.length > 0 && this.findMainItem(list) == null) {
          list[0].tag = "MAIN"
        }
        this.$emit('input', list)
      }
    },

    activeItem () {
      return this.findMainItem(this.value)
    }
  },

  methods: {
    select (selectedItem) {
      this.items = this.items.map(item => item === selectedItem ? {...selectedItem, tag: "MAIN"} : {...item, tag: null})
    },

    findMainItem (list) {
      return list && list.find(item => item.tag && (item.tag === "MAIN" || item.tag.name === "MAIN")) || null
    }
  }
}
</script>